import script from "./lottory.vue?vue&type=script&setup=true&lang=js"
export * from "./lottory.vue?vue&type=script&setup=true&lang=js"

import "./lottory.vue?vue&type=style&index=0&id=78c0a3c9&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-78c0a3c9"]])

export default __exports__